import type { ReactNode } from 'react'
import React from 'react'

import type { SearchStandardRecipeItem, StandardRecipeItem } from '@library/api-menu-experience'

import { RecipeTile } from '../RecipeGrid/RecipeTile'
import type { RecipeTileProps } from '../RecipeGrid/RecipeTile'

export type MobileSearchRecipeTileProps = Omit<
  RecipeTileProps,
  'insideOverflow' | 'recipe' | 'renderFlexPortionBadge'
> & {
  recipe: SearchStandardRecipeItem
  flexPortionControl?: ReactNode
}

export const MobileSearchRecipeTile = ({
  recipe,
  flexPortionControl,
  isInBasket,
  ...recipeTileProps
}: MobileSearchRecipeTileProps) => {
  // Webclient currently always sends a delivery date. Guest search responses without one omit
  // availability, so preserve the native-app behaviour by treating omitted values as available.
  const standardRecipe: StandardRecipeItem = {
    ...recipe,
    isAvailable: recipe.isAvailable ?? true,
    portions: recipe.portions?.map((portion) => ({
      ...portion,
      isAvailable: portion.isAvailable ?? true,
    })),
  }

  return (
    <RecipeTile
      {...recipeTileProps}
      insideOverflow
      isInBasket={isInBasket}
      recipe={standardRecipe}
      renderFlexPortionBadge={
        isInBasket && flexPortionControl ? () => flexPortionControl : undefined
      }
    />
  )
}
